import React from 'react';

const LicenseExpiredPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>Срок действия лицензии закончился</h2>
      <p>Необходимо связаться с поставщиком системы.</p>
    </div>
  );
};

export default LicenseExpiredPage;


